import { supabase } from '@/shared/lib/supabase';
import type {
  TransmissaoFonte,
  TransmissaoFonteInsert,
  TransmissaoFonteUpdate,
} from '@/shared/types';
import type { ITransmissaoRepository } from '../domain/ports/ITransmissaoRepository';

export const transmissaoRepository: ITransmissaoRepository = {

  async listarPorEmpresa(empresaId: string): Promise<TransmissaoFonte[]> {
    const { data, error } = await supabase
      .from('transmissao_fontes' as never)
      .select('*')
      .eq('empresa_id', empresaId)
      .order('ordem', { ascending: true })
      .order('nome', { ascending: true });

    if (error) throw error;
    return (data ?? []) as TransmissaoFonte[];
  },

  async buscarPorId(empresaId: string, id: string): Promise<TransmissaoFonte | null> {
    const { data, error } = await supabase
      .from('transmissao_fontes' as never)
      .select('*')
      .eq('empresa_id', empresaId)
      .eq('id', id)
      .maybeSingle();

    if (error) throw error;
    return data as TransmissaoFonte | null;
  },

  async buscarParaTela(telaId: string, id: string): Promise<TransmissaoFonte | null> {
    const { data, error } = await supabase.rpc(
      'player_buscar_transmissao_fonte' as never,
      { p_tela_id: telaId, p_id: id } as never,
    );
    if (error) throw error;
    const linhas = (data ?? []) as TransmissaoFonte[];
    return linhas[0] ?? null;
  },

  async criar(payload: TransmissaoFonteInsert): Promise<TransmissaoFonte> {
    const { data, error } = await supabase
      .from('transmissao_fontes' as never)
      .insert(payload as never)
      .select()
      .single();

    if (error) throw error;
    return data as TransmissaoFonte;
  },

  async atualizar(empresaId: string, id: string, campos: TransmissaoFonteUpdate): Promise<TransmissaoFonte> {
    const { data, error } = await supabase
      .from('transmissao_fontes' as never)
      .update(campos as never)
      .eq('empresa_id', empresaId)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data as TransmissaoFonte;
  },

  async remover(empresaId: string, id: string): Promise<void> {
    const { error } = await supabase
      .from('transmissao_fontes' as never)
      .delete()
      .eq('empresa_id', empresaId)
      .eq('id', id);

    if (error) throw error;
  },
};
